export class JiraErrorDetail {
  constructor(private readonly error: string, private readonly field: string | null, private readonly value: string | null) {}

  getError() {
    return this.error;
  }

  getField() {
    return this.field;
  }

  getValue() {
    return this.value;
  }
}
